import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";

export const useDocumentAuthoringAccess = () => {
  const user = useAuthenticatedUser();
  const isResolved = !user.isLoading && user.isAuthenticated;

  return {
    isResolved,
    hasDocumentAuthoring: isResolved && user.organization.features.includes("document_authoring"),
  };
};
